import React, { CSSProperties } from "react";
import {
  makeStyles,
  Drawer,
  Box,
  IconButton,
  Typography,
} from "@material-ui/core";

import PerfectScrollbar from "react-perfect-scrollbar";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  root: {},
  mobileDrawer: {
    width: 400,
    height: "100vh",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  close: {
    // margin:"-4px -8px",
    left: 0,
    marginTop: 4,
    color: theme.palette.primary.main,
    position: "absolute",
  },
  iconLeft: {
    left: 16,
  },
  iconRight: {
    right: 16,
  },
  alignCenter: {
    textAlign: "center",
  },
}));

interface BaseDrawerProps {
  open: boolean;
  onClose: () => void;
  ExitIcon?: any;
  anchor?: "left" | "top" | "right" | "bottom";
  title?: string;
  children?: any;
  onBack?: () => void;
  paperStyle?: CSSProperties;
  titleComponent?: React.ReactNode;
}

const BaseDrawer: React.FC<BaseDrawerProps> = ({
  onClose,
  open,
  anchor,
  ExitIcon,
  title,
  children,
  onBack,
  paperStyle,
  titleComponent,
}) => {
  const classes = useStyles();

  const getDefaultBackIcon = () => {
    if (onBack) {
      switch (anchor) {
        case "bottom":
          return <ExpandMoreIcon />;
        case "top":
          return <ExpandMoreIcon style={{ transform: "rotate(180deg)" }} />;
        case "right":
          return <ExpandMoreIcon style={{ transform: "rotate(90deg)" }} />;
        case "left":
          return <ExpandMoreIcon style={{ transform: "rotate(90deg)" }} />;
        default:
          return <ExpandMoreIcon style={{ transform: "rotate(90deg)" }} />;
      }
    } else return <CloseIcon />;
  };

  // const onExit = () => {
  //   onClose()
  // }

  return (
    <Drawer
      anchor={anchor || "right"}
      classes={{ paper: classes.mobileDrawer }}
      open={open}
      onClose={onClose}
      variant="temporary"
      PaperProps={{ style: paperStyle }}
    >
      <Box height="100vh" display="flex" flexDirection="column">
        <PerfectScrollbar options={{ suppressScrollX: true }}>
          <Box p={3} height="100vh">
            <Box className={classes.title}>
              <IconButton
                className={classes.close}
                onClick={onBack ? () => onBack() : () => onClose()}
              >
                {ExitIcon || getDefaultBackIcon()}
              </IconButton>
              {title !== undefined && (
                <Typography variant="subtitle1" style={{ alignSelf: "center" }}>
                  {title}
                </Typography>
              )}
              {titleComponent}
            </Box>
            <Box py={2} />
            {children}
          </Box>
        </PerfectScrollbar>
      </Box>
    </Drawer>
  );
};

export default BaseDrawer;
